import React from "react";
import { Stack } from "@mui/material";

import { HubHookFormDatePicker, HubHookFormInput } from "../../components";
import { HubActionDialog } from "../HubActionDialog";
import { getDescriptions } from "./helper";

import dayjs from "dayjs";

export const ConfirmWorkOrderStation = ({
  isOpen = false,
  isClosing = false,
  onClose = () => {},
  onSubmit = () => {},
  payload = {},
  data = {},
  ...rest
}) => {
  let route;
  let current = data?.routes?.find((r) => r.id === data.currentRoute);
  if (payload?.routeId)
    route = data?.routes?.find((r) => r.id === payload.routeId);

  const stationLabel = <strong>{route?.station?.label}</strong>;
  const DESCRIPTIONS = getDescriptions(stationLabel);

  let description = DESCRIPTIONS.default;

  let isRework = false;
  if (route) {
    if (route.order > current?.order) {
      description = DESCRIPTIONS.advance;
    } else {
      isRework = true;
      description = DESCRIPTIONS.rework;
    }
  }

  if (isClosing) description = DESCRIPTIONS.closing;

  const FormCenter = (
    <Stack direction="row" gap="15px" width="100%">
      {isRework && (
        <HubHookFormInput
          name="rework"
          label="Completed"
          placeholder="Completed"
          rules={{
            max: {
              value: data?.quantity,
              message: "Completed should not exceed work order quantity",
            },
          }}
          disableHelperText={false}
          required
          isNumber
        />
      )}
      {isClosing && (
        <HubHookFormDatePicker
          name="endDate"
          label="End Date"
          defaultValue={dayjs().toISOString()}
          placeholder="MM/DD/YYYY"
          required
        />
      )}
    </Stack>
  );

  const handleSubmit = (formData) => {
    const rework = Number(formData?.rework);
    const newPayload = isClosing
      ? {
          endDate: dayjs(formData?.endDate).toISOString(),
        }
      : {
          ...payload,
          ...(rework ? { rework } : {}),
        };
    onSubmit(newPayload);
  };

  const includeForm = isRework || isClosing;
  return (
    <HubActionDialog
      onClose={onClose}
      open={isOpen}
      title={isClosing ? "Work Order Close" : "Work Order Update!"}
      description={description}
      handleSubmit={handleSubmit}
      submitLabel={isClosing ? "Confirm Close" : "Confirm Update"}
      action="warning"
      {...(includeForm ? { children: FormCenter } : {})}
      {...rest}
    />
  );
};

export default ConfirmWorkOrderStation;
